<div class="container-fluid mat-elevation-z2 rounded p-4">
    <h1 class="text-center">Update Profile</h1>

    <mat-divider class="mt-4 mb-4"></mat-divider>
    <!-- Inputs -->
    <form class="row" [formGroup]="editUserForm">
        <div class="row">
            <div class="col-12 col-md-6 col-lg-6">
                <mat-form-field appearance="outline" class="w-100 ps-0">
                    <mat-label>First name</mat-label>
                    <mat-error>Field cannot be blank</mat-error>
                    <input [readonly]="!isEditing" matInput placeholder="Ex: Jacob" formControlName="firstName"
                        required>
                    <mat-hint>Edit your first name</mat-hint>
                </mat-form-field>
            </div>

            <div class="col-12 col-md-6 col-lg-6">
                <mat-form-field appearance="outline" class="w-100 ps-0">
                    <mat-label>Last name</mat-label>
                    <mat-error>Field cannot be blank</mat-error>
                    <input [readonly]="!isEditing" matInput placeholder="Ex: Jacob" formControlName="lastName" required>
                    <mat-hint>Edit your last name</mat-hint>
                </mat-form-field>
            </div>
        </div>

        <div class="row mt-3">
            <div class="col-12 col-md-6 col-lg-6">
                <mat-form-field appearance="outline" class="w-100 ps-0">
                    <mat-label>Email</mat-label>
                    <mat-error *ngIf="editUserForm.controls['email'].hasError('email')">Field must be email</mat-error>
                    <mat-error *ngIf="editUserForm.controls['email'].hasError('required')">Field cannot be
                        blank</mat-error>
                    <input [readonly]="!isEditing" matInput type="email" placeholder="Ex: example@example.com"
                        formControlName="email" required>
                    <mat-hint>Edit your email</mat-hint>
                </mat-form-field>
            </div>

            <div class="col-12 col-md-6 col-lg-6">
                <mat-form-field appearance="outline" class="w-100 ps-0">
                    <mat-label>Password</mat-label>
                    <mat-error *ngIf="editUserForm.controls['password'].hasError('required')">Field cannot be
                        blank</mat-error>
                    <mat-error
                        *ngIf="editUserForm.controls['password'].hasError('minlength') || editUserForm.controls['password'].hasError('maxlength')">password
                        must contain
                        between
                        5 and 60 characters</mat-error>
                    <input [readonly]="!isEditing" matInput type="password" formControlName="password" required>
                    <mat-hint>Edit your password</mat-hint>
                </mat-form-field>
            </div>
        </div>
    </form>

    <mat-divider class="mb-4 mt-4"></mat-divider>

    <!-- Actions -->
    <div class="row d-flex justify-content-around">
        <button *ngIf="!isEditing" mat-raised-button class="w-25" color="primary"
            (click)="isEditing = true">Edit</button>
        <button class="w-25" [disabled]="isLoading" *ngIf="isEditing" mat-raised-button color="warn"
            (click)="onCancelClicked()">Cancel</button>
        <button class="w-25" [disabled]="isLoading || !editUserForm.valid" *ngIf="isEditing" mat-raised-button
            color="primary" (click)="onSubmitForm()">
            <span *ngIf="!isLoading">
                Save
            </span>
            <mat-spinner *ngIf="isLoading" [diameter]="30" [strokeWidth]="3" class="mx-auto mat-spinner"></mat-spinner>
        </button>
    </div>
</div>